<template>
	<accountLayout :title="$t('account.scanRegisterTitle')" :subtitle="$t('account.scanRegisterSubtitle')"
		current="account" :wide="true" ref="layout">
		<el-form :model="form" :rules="rules" ref="form" @submit.native.prevent="onSubmit"
			:label-position="labelPosition" :label-width="labelWidth">
			<el-form-item prop="name" :label="$t('account.name')">
				<el-input v-model="form.name" :placeholder="$t('account.name')"></el-input>
			</el-form-item>
			<el-form-item prop="email" :label="$t('account.email')">
				<el-input v-model="form.email" :placeholder="$t('account.email')"></el-input>
			</el-form-item>
			<el-form-item prop="password" :label="$t('account.password')">
				<el-input v-model="form.password" type="password" show-password
					:placeholder="$t('account.password')"></el-input>
			</el-form-item>
			<el-form-item prop="country" :label="$t('account.country')">
				<el-input v-model="form.country" :placeholder="$t('account.country')"></el-input>
			</el-form-item>
			<el-form-item prop="hospital" :label="$t('account.hospital')">
				<el-input v-model="form.hospital" :placeholder="$t('account.hospital')"></el-input>
			</el-form-item>
			<el-form-item prop="product_id" :label="$t('account.product')">
				<el-select filterable clearable style="width:100%" v-model="form.product_id"
					:placeholder="$t('account.productPlaceholder')">
					<el-option v-for="item in productOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<!--
			 <el-form-item prop="product_model" :label="$t('account.productModel')">
				<el-input v-model="form.product_model" :placeholder="$t('account.productModel')"></el-input>
			</el-form-item>
			-->
			<el-form-item prop="serial_no" :label="$t('account.serialNo')">
				<el-input v-model="form.serial_no" :placeholder="$t('account.serialNo')"></el-input>
			</el-form-item>
			<el-form-item prop="captcha" :label="$t('account.captcha')">
				<div class="captcha-input-group">
					<el-input v-model="form.captcha" :placeholder="$t('account.captchaPlaceholder')"></el-input>
					<img v-if="captchaImg" :src="captchaImg" @click="loadCaptcha" class="captcha-img" alt="captcha" />
				</div>
			</el-form-item>
			<el-form-item>
				<el-button class="account-submit-btn" :loading="loading" @click="onSubmit"
					style="width:100%">{{ $t('account.register') }}</el-button>
			</el-form-item>
		</el-form>
		<div class="account-links">
			<span>{{ $t('account.hasAccount') }}</span>
			<router-link :to="'/login'">{{ $t('account.goLogin') }}</router-link>
		</div>
	</accountLayout>
</template>

<script>
import accountLayout from "@/components/c/accountLayout.vue"
import { scanRegisterApi, getProductListApi, getCaptchaApi } from "@/api/login.js"
export default {
	components: { accountLayout },
	data() {
		return {
			form: { name: '', email: '', password: '', country: '', hospital: '', product_id: '', product_model: '', serial_no: '', captcha: '', captcha_key: '' },
			productOptions: [],
			loading: false,
			captchaImg: '',
			labelPosition: window.innerWidth >= 1200 ? 'left' : 'top',
			labelWidth: window.innerWidth >= 1200 ? '120px' : 'auto',
			rules: {
				name: [{ required: true, message: this.$t('account.nameRequired'), trigger: 'blur' }],
				email: [
					{ required: true, message: this.$t('account.emailRequired'), trigger: 'blur' },
					{ type: 'email', message: this.$t('account.emailInvalid'), trigger: 'blur' }
				],
				password: [
					{ required: true, message: this.$t('account.passwordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('account.passwordMin'), trigger: 'blur' }
				],
				country: [{ required: true, message: this.$t('account.countryRequired'), trigger: 'blur' }],
				hospital: [{ required: true, message: this.$t('account.hospitalRequired'), trigger: 'blur' }],
				product_id: [{ required: true, message: this.$t('account.productRequired'), trigger: 'change' }],
				serial_no: [{ required: true, message: this.$t('account.serialNoRequired'), trigger: 'blur' }],
				captcha: [{ required: true, message: this.$t('account.captchaRequired'), trigger: 'blur' }]
			}
		}
	},
	computed: {
		langPrefix() { const l = localStorage.getItem('i18n-lang') || 'zh'; return l == 'zh' ? '/cn' : '/en' }
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		this.loadProducts()
		this.loadCaptcha()
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		handleResize() {
			this.labelPosition = window.innerWidth >= 1200 ? 'left' : 'top'
			this.labelWidth = window.innerWidth >= 1200 ? '120px' : 'auto'
		},
		loadProducts() {
			getProductListApi().then(res => {
				this.productOptions = res.data || []
			}).catch(() => {})
		},
		loadCaptcha() {
			getCaptchaApi().then(res => {
				this.captchaImg = res.data.captcha
				this.form.captcha_key = res.data.key
				this.form.captcha = ''
			}).catch(() => {})
		},
		onSubmit() {
			this.$refs.form.validate(valid => {
				if (!valid) return
				this.loading = true
				scanRegisterApi({...this.form, site: this.langPrefix === '/cn' ? 1 : 2}).then(res => {
					this.$message.success(res.msg)
					localStorage.setItem('user_real_name', this.form.name)
					this.$store.commit('setUserRealName', this.form.name)
					this.$router.push(this.langPrefix + '/login')
				}).catch(() => {
					// 验证码一次性，失败后刷新
					this.loadCaptcha()
				}).finally(() => { this.loading = false })
			})
		}
	}
}
</script>

<style scoped lang="scss">
.account-submit-btn {
	background: #000000;
	border-color: #000000;
	color: #FFFFFF;
	height: 44px;
	border-radius: 0;
	font-size: 15px;

	&:hover,
	&:focus {
		background: #333333;
		border-color: #333333;
		color: #FFFFFF;
	}
}

.captcha-input-group {
	display: flex;
	align-items: center;
	gap: 10px;

	::v-deep .el-input {
		flex: 1;
	}
}

.captcha-img {
	height: 38px;
	width: 110px;
	cursor: pointer;
	border: 1px solid #DCDFE6;
	border-radius: 0;
}

.account-links {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	margin-top: 20px;

	span {
		color: #999999;
	}

	a {
		color: #000000;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
}

@media screen and (max-width: 768px) {
	.account-links {
		flex-direction: column;
		gap: 6px;
	}
}
</style>
